export type PrismInputDir = 'N' | 'S' | 'E' | 'W';

/**
 * Shared direction-rotation tables for prism geometry. The Prism entity uses
 * these to lay out its R/G/B output dots; PrismHelperOverlay uses them to
 * place the output-direction arrows. Keeping a single source of truth ensures
 * the visual overlay and the prism rendering can never disagree about which
 * face emits which color.
 */
export const OPPOSITE: Record<PrismInputDir, PrismInputDir> = {
  N: 'S',
  S: 'N',
  E: 'W',
  W: 'E',
};

/** 90° counter-clockwise in screen coordinates (+y down). */
export const CCW_SCREEN: Record<PrismInputDir, PrismInputDir> = {
  N: 'W',
  W: 'S',
  S: 'E',
  E: 'N',
};

/** 90° clockwise in screen coordinates (+y down). */
export const CW_SCREEN: Record<PrismInputDir, PrismInputDir> = {
  N: 'E',
  E: 'S',
  S: 'W',
  W: 'N',
};
